module.exports = __webpack_public_path__ + "img/control_de_calidad2_4-3_682.60bc195f.jpg";